import Axios from "axios";
import { getApiConfig } from "../../config/apiConfig";
import { adalApiFetch } from "../../config/azureConfig";
import { GET_OUT_OF_STOCK_LIST, UPDATE_OUT_OF_STOCK_LIST } from "../constants/action-types";


const API_CONFIG = getApiConfig();

/* 
  Update an Out of Stock list.
*/
export const updateOutOfStockList = (outOfStockList, callback) => dispatch => {
    adalApiFetch(Axios, `${API_CONFIG.URL}/outOfStock/updateOutOfStockList`, {
        method: "post",
        data: outOfStockList
    }).then(res => {
        dispatch({
            type: UPDATE_OUT_OF_STOCK_LIST,
            payload: res.data
        });

        callback(true);
    }).catch((error) => {
        console.log(`Exception Occurred: ${error}`);
        callback(false);
    })
};

/*
    Get Out Of Stock list
*/
export const getOutOfStockProducts = (distributorId, callback) => dispatch => {
    adalApiFetch(Axios, `${API_CONFIG.URL}/outOfStock/outOfStockList/${distributorId}`, {
        method: "get"
    }).then(res => {
        dispatch({
            type: GET_OUT_OF_STOCK_LIST,
            payload: res.data
        });

        callback(true);
    }).catch((error) => {
        console.log(`Exception Occurred: ${error}`);
        callback(false);
    })
};